
import { Card, Col, Row, Typography, Image, Space } from 'antd'
import React from 'react'
import GreenerEnergy from '@assets/KPMG/greenerEnergy.png'
import styles from "./FAQ.module.scss";

export const FAQcard = (props: any) => {
    const { data } = props
    console.log(data);


    return (
        <>
            {data.map((item: any, index: number) => (
                <>
                    <Card>
                        <Row gutter={16}>
                            <Col span={8}>
                                <Image
                                    src={GreenerEnergy}
                                    preview={false}
                                />
                            </Col >
                            <Col span={16}>
                                <Col>
                                    {item.description}
                                </Col>
                                <Col>
                                    <Row style={{ marginTop: styles.whitespace3 }}>
                                        <Col span={5}>
                                            <Typography.Title
                                                level={5}
                                            >
                                                Sector
                                            </Typography.Title>
                                            <Typography.Text>
                                                {item.sector}
                                            </Typography.Text>
                                        </Col>
                                        <Col span={9}>
                                            <Typography.Title
                                                level={5}
                                            >
                                                Location
                                            </Typography.Title>
                                            <Typography.Text>
                                                {item.location}
                                            </Typography.Text>
                                        </Col>
                                        <Col span={10}>
                                            <Typography.Title
                                                level={5}
                                            >
                                                Link
                                            </Typography.Title>
                                            <Typography.Text>
                                                <a> {item.link} </a>
                                            </Typography.Text>
                                        </Col>
                                    </Row>
                                </Col>
                            </Col >
                        </Row>
                    </Card>
                </>
            ))}

        </>
    )
}